<div id="passport_modal" class="modal  custom-modal fade" role="dialog">
    <div class="modal-dialog   modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="zero_optn_grp_form_title"> {{header}}</h5>
                <button type="button" class="close" data-dismiss="modal" (click)="onReset()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="pasForm" (ngSubmit)="onSubmitPassport()" class="horizontal-form" method="post" enctype="multipart/form-data">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Country <span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="country_id">
                                   <option value="">Select</option>
                                   <option value="1">1</option>
                                   <option value="2">2</option>
                                </select>
                                <div *ngIf="submitted && passportErrorMsg.country_id.errors" class="form-error">
                                    <div *ngIf="passportErrorMsg.country_id.errors.required">Country is required !</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Passport Number<span class="text-danger">*</span></label>
                                <input class="form-control" type="text" formControlName="passport_no" placeholder="Passport Number">
                                <div *ngIf="submitted && passportErrorMsg.passport_no.errors" class="form-error">
                                    <div *ngIf="passportErrorMsg.passport_no.errors.required">Passport Number is required !</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Valid From<span class="text-danger">*</span></label>
                                <input class="form-control" type="date" formControlName="valid_from">
                                <div *ngIf="submitted && passportErrorMsg.valid_from.errors" class="form-error">
                                    <div *ngIf="passportErrorMsg.valid_from.errors.required">Valid from is required !</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Valid To<span class="text-danger">*</span></label>
                                <input class="form-control" type="date" formControlName="valid_to">
                                <div *ngIf="submitted && passportErrorMsg.valid_to.errors" class="form-error">
                                    <div *ngIf="passportErrorMsg.valid_to.errors.required">Valid to is required !</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Attachment<span class="text-danger">*</span></label>
                                <input class="form-control" type="file" (change)="onFileChange($event)" formControlName="attachment">
                                <div *ngIf="submitted && passportErrorMsg.attachment.errors" class="form-error">
                                    <div *ngIf="passportErrorMsg.attachment.errors.required">attachment is required !</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary btn-sm "><span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span><i class="fa fa-save"></i> SAVE</button>
                    <button type="button" class="btn btn-danger btn-sm" (click)="onReset()" data-dismiss="modal">Close</button>
                </div>
            </form>
        </div>
    </div>
</div>